module.exports = __webpack_public_path__ + "img/rotateLogo_EN.2c922bd6.png";